import React, { Suspense } from "react";
import LoadingSpinner from "../Icons/LoadingSpinner";

// Other Routes
import { HrRoutes } from "./ProtectedHrRoutes";
import { AdminManagerRoutes } from "./ProtectedAdminM.Route";
import { AdminRoutes } from "./ProtectedAdmin";
import { renderITRoutes } from "./ProtectedAdminHrItRoutes";
import { TrainingRoutes } from "./ProtecctedTrainingRoutes";

// Dashboard
const Dashboard = React.lazy(() => import("../pages/Dashboard"));

// Task
const TaskList = React.lazy(() => import("../pages/Dashboard/task/list"));
const TaskDetail = React.lazy(() => import("../pages/Dashboard/task/detail"));

// Overtime
const Overtime = React.lazy(() => import("../pages/Dashboard/overtime/list"));


// Profile
const Profile = React.lazy(() => import("../pages/Profile/Profile"));
const Settings = React.lazy(() => import("../pages/Settings/Settings"));
const SettingProfile = React.lazy(
  () => import("../pages/Settings/Profile/SettingProfile")
);

// Leaves
const Leaves = React.lazy(
  () => import("../pages/Dashboard/LeaveTracker/leaves/list")
);
const AddLeave = React.lazy(
  () => import("../pages/Dashboard/LeaveTracker/leaves/add")
);
const EditLeave = React.lazy(
  () => import("../pages/Dashboard/LeaveTracker/leaves/edit")
);

// Work-Report
const DailyTeamReport = React.lazy(
  () => import("../pages/Dashboard/ProjectTracker/daily-reports/team")
);
const DailyReport = React.lazy(
  () => import("../pages/Dashboard/Projects/DailyReport")
);
const AddWorkStatus = React.lazy(
  () => import("../pages/Dashboard/Projects/AddStatus")
);

const EmployeeSelfFeedback = React.lazy(
  () => import("../pages/feedback/employee-self-feedback")
);

// blog
const NewBlog  = React.lazy(() => import('../pages/Dashboard/blog/new'));
const AllBlog  = React.lazy(() => import('../pages/Dashboard/blog/list'));
const BlogPage  = React.lazy(() => import('../pages/Dashboard/blog/view'));

// Messenger
const Messenger = React.lazy(() => import("../pages/Dashboard/messenger/list"));

const loadingSpinner = (
  <LoadingSpinner className="mr-2 h-full w-14 animate-spin" />
);
const createSuspenseElement = (Component: React.ComponentType<any>) => (
  <Suspense fallback={loadingSpinner}>
    <Component />
  </Suspense>
);

export const childRoutes = [
  ...AdminManagerRoutes,
  ...HrRoutes,
  ...AdminRoutes,
  ...renderITRoutes,
  ...TrainingRoutes,
  {
    path: "/dashboard",
    element: createSuspenseElement(Dashboard),
    title: "Dashboard",
    role: ["admin", "employee"],
  },
  {
    path: "/profile",
    element: createSuspenseElement(Profile),
    title: "Profile",
    role: ["admin", "employee"],
  },
  {
    path: "/settings",
    element: createSuspenseElement(Settings),
    title: "Settings",
    role: ["admin", "employee"],
    children: [
      {
        path: "/settings",
        element: createSuspenseElement(SettingProfile),
        title: "Notification Details",
        roles: ["admin", "employee"],
      },
      {
        path: "/settings/account",
        element: createSuspenseElement(SettingProfile),
        title: "Account Settings",
        roles: ["admin", "employee"],
      },
      {
        path: "/settings/appearance",
        element: createSuspenseElement(() => <div>Appearance</div>),
        title: "Appearance",
        roles: ["admin", "employee"],
      },
      {
        path: "/settings/notifications",
        element: createSuspenseElement(() => <div>Notifications</div>),
        title: "Notifications",
        roles: ["admin", "employee"],
      },
      {
        path: "/settings/display",
        element: createSuspenseElement(() => <div>Display</div>),
        title: "Display",
        roles: ["admin", "employee"],
      },
    ],
  },
  {
    path: "/dashboard/leaves",
    element: createSuspenseElement(Leaves),
    title: "Leaves",
    role: ["admin"],
  },
  {
    path: "/dashboard/leaves/add-leave",
    element: createSuspenseElement(AddLeave),
    title: "Add Leave",
    role: ["admin", "employee"],
  },
  {
    path: "/dashboard/leaves/edit-leave/:leaveid",
    element: createSuspenseElement(EditLeave),
    title: "Edit Leave",
    role: ["admin", "employee"],
  },
  {
    path: "/task-list",
    element: createSuspenseElement(TaskList),
    title: "Task List",
    role: ["admin", "employee"],
  },
  {
    path: "/overtime",
    element: createSuspenseElement(Overtime),
    title: "Overtime",
    role: ["admin"],
  },
  {
    path: "/task/:id",
    element: createSuspenseElement(TaskDetail),
    title: "Task List",
    role: ["admin", "employee"],
  },
  {
    path: "/dashboard/projects/daily-report",
    element: createSuspenseElement(DailyReport),
    title: "Daily Report",
    role: ["admin"],
  },
  {
    path: "/dashboard/projects/daily-team-report",
    element: createSuspenseElement(DailyTeamReport),
    title: "Daily Team Report",
    role: ["Manager"],
  },
  {
    path: "/dashboard/projects/daily-report/add-daily-report",
    element: createSuspenseElement(AddWorkStatus),
    title: "Add Daily Report",
    role: ["admin", "employee"],
  },
  {
    path: "/feedback/employee-self-feedback",
    element: createSuspenseElement(EmployeeSelfFeedback),
    title: "Add Daily Report",
    role: ["employee"],
  },
  {
    path: "/messenger",
    element: createSuspenseElement(Messenger),
    title: "Messenger",
    role: ["admin", "Manager"],
  },
  {
    path: "/new-blog",
    element: createSuspenseElement(NewBlog),
    title: "Add New Blog",
    role: ['admin'],
  },
  {
    path: "/blogs",
    element: createSuspenseElement(AllBlog),
    title: "Blog",
    role: ['admin'],
  },
    {
    path: "/blogs/:blogId",
    element: createSuspenseElement(BlogPage),
    title: "Blog View",
    role: ['admin'],
  }
];
